import {differenceInYears, differenceInDays} from "date-fns";
import { IProfile } from "StateInterface";
declare const window: any;
export function isEmail(email) {
    const regex = /^((([a-z]|\d|[!#\$%&"\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&"\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
    return regex.test(email);
}

export const isMobile = (value) => {
    const regex = /[6-9][0-9]{9}$/;
    return regex.test(value);
};

export const startsWithZero = (value) => {
    const regex = /^[0]+[0-9]*/;
    return regex.test(value);
};

export const diffYears = (end: Date, start: Date) => {
    return differenceInYears(end, start);
};

export const diffDays = (end: Date, start: Date) => {
    return differenceInDays(end, start);
};
export const isValidPan = (value) => {
    const regex = /^([a-zA-Z]){3}([CPHFATBLJG]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$/;
    return regex.test(value);
};

export function addslashes( str ) {
    return (str + "").replace(/[\\"']/g, "\\$&").replace(/\u0000/g, "\\0");
}

export function getJsonFromUrl() {
    const query = location.search.substr(1);
    const result = {};
    query.split("&").forEach((part) => {
      const item = part.split("=");
      result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
}

export function getPathName(path) {
    return path && path !== "sl" ? `/${path}` : "/";
}

export function cloneArrayOrObject(source) {
    return JSON.parse(JSON.stringify(source));
}

export function getRootRouteFromAndroidPath(route: string) {
    return route.split("/")[2];
}

export function capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function getRegexFromString(regex) {
    const firstIndex = regex.indexOf("/");
    const lastIndex = regex.lastIndexOf("/");
    return regex.substring(firstIndex + 1, lastIndex);
}

export function unflatten(object, profile?: IProfile) {
    const result = profile || {};
    Object.keys(object).forEach( (k) =>  {
        setValue(result, k, object[k]);
    });
    return result;
}

export const unFlattenForm = (form) => {
  return form.map(data => unflatten(data['fields'].reduce((obj, item) => ({...obj, [item['identifier']] : item['value']}), {})));
};

function setValue(object, path, value,) {
    const way = path.split(":"),
        last = way.pop();

    way.reduce( (o, k, i, kk) =>  {
        return o[k] = o[k] || (isFinite(i + 1 in kk ? kk[i + 1] : last) ? [] : {});
    }, object)[last] = value;
}

  
export const isNativeAndroid = () => {
  return !!(window.Android && window.Android.notify);
};
  
export const isWebview = () => {
    const standalone = window.navigator.standalone;
    const userAgent = window.navigator.userAgent.toLowerCase();
    const safari = /safari/.test(userAgent);
    const ios = /iphone|ipod|ipad/.test(userAgent);
  
    if (userAgent.includes("wv") || (ios && !standalone && !safari)) {
      return true;
    } else {
      return false;
    }
};
  
export const isMobileOrTab = () => {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
        /Windows Phone/i
    ];
    
    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
}

export const readableDateFormat = (date: number | Date): string => {
  return new Date(date).toDateString().split(" ").splice(1, 3).join(" ");
}

export const shouldDisableScroll = (node: {element: HTMLElement, disabled: boolean}) => {
  node.element.style.overflowY = node.disabled ? "hidden" : "scroll";
  node.element.style.pointerEvents = node.disabled ? "none" : "auto";
}

export const getDaysInMillSec = (day: number) => 1000 * 60 * 60 * 24 * day;
